module.exports = __webpack_public_path__ + "static/media/egg-fried.12cf37a7.svg";